import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Online Web Development Using Angular</h1>
            <br />
          </div>
          {/* <div className="imgSection">
            <img
              src={require("../../../images/courses/angular.png")}
              alt=""
            />
          </div> */}
          <div className="heading">
            {/*  */}

            <h4 style={{ color: "blue" }}>About Course</h4>
            <ul>
              <li>
                This course will run live an online through Online Learning
                Platform.{" "}
              </li>
              <li>
                {" "}
                You will be provided a online class room / meeting link daily on
                your registered mail id /WhatsApp number{" "}
              </li>
              <li>
                You will be assigned with an instructor or mentor for solving
                your queries regarding the course on a 24 X 7 basis.{" "}
              </li>
              <li>
                {" "}
                You will be provided with module wise Class Room PPT, Course
                Material, MCQ types of question, Interview Questions with
                Answers, Solved Practical Assignment for Practice and Unsolved
                Practical Question.{" "}
              </li>
              <li>
                {" "}
                For any questions or doubts, separates sessions will be arranged
                for you in a specified duration of the course.{" "}
              </li>
              <li> One mini-project will be covered during course.</li>
              <li>
                {" "}
                The problem solving facility with mentor will be provided in
                English, Marathi, and Hindi Language.{" "}
              </li>
              <li>
                {" "}
                A digital certificate from Logipool Infotech will be given to
                you after successful completion of the course.{" "}
              </li>
              <li>
                Separate Online Internship Completion Certificate from
                TechnoGrowth Software Solution Pvt. Ltd. Pune will be provided
                to you for course duration period{" "}
              </li>
            </ul>
            {/*  */}
            <h3 style={{ color: "blue" }}>Course Content</h3>
              <h4> Course Outline & Typescript Fundamentals </h4>
              <ul>
                <li>What is Typescript</li>
                <li> Data Types </li>
                <li>How to Define Type script Variable </li>
                <li> typescript Operator </li>
                <li>Typescript Functions </li>
                <li>Typescript Built-in Function Types </li>
                <li>Typescript Arrays </li>
                <li>Typescript Interfaces </li>
              </ul>
              <h4> Prerequisite Brush-ups</h4>
              <ul>
                <li>Revision to HTML5 and CSS3</li>
              </ul>
              <h4> Introduction & Basics of Angular </h4>
              <ul>
                <li>Introduction to Angular</li>
                <li>Goals of Angular </li>
                <li>Code Compilation Process in Angular </li>
                <li>Angular Architecture </li>
                <li>Building Blocks of Angular </li>
              </ul>
              <h4> Prepare Development Environment </h4>
              <ul>
                <li>Installation Requirement</li>
                <li>Setup Development Environment </li>
                <li>Overview of Angular Packages </li>
                <li>Angular Application Folder Structure </li>
              </ul>
              <h4> Angular Component and Modules </h4>
              <ul>
                <li>What is Angular Component and Modules ?</li>
                <li>Cerate Component using Angular CLI </li>
                <li> @Component Template VS TemplateURL</li>
                <li>Component Nesting</li>
              </ul>
              <h4> Angular Data Binding</h4>
              <ul>
                <li>Data Binding by Interpolation</li>
                <li>Property Binding </li>
                <li>Attribute Binding </li>
                <li>Class Binding </li>
                <li>Event Binding</li>
                <li>Template Variable </li>
                <li>Angular @ View Child</li>
                <li>Two Way Data Binding</li>
              </ul>
              <h4> Angular Directives </h4>
              <ul>
                <li>Angular Structural Directives,*ngif, Else,</li>
                <li>* ngSwitch </li>
                <li>*ngFor </li>
                <li>Trackby NgFor </li>
                <li> Grouping with ngfor</li>
                <li>ngstyle </li>
                <li>ngclass </li>
              </ul>
              <h4> Using Angular Pipes </h4>
              <ul>
                <li>Introduction to Pipes</li>
                <li>Parameterized Pipes </li>
                <li>Multiple Pipes </li>
                <li>Pipes with String </li>
                <li>Pipes with Dates </li>
                <li> Percent</li>
                <li>Decimal </li>
                <li>Currency </li>
                <li> Custom Pipes </li>
              </ul>
              <h4> Angular Routing </h4>
              <ul>
                <li>Introduction to Routing</li>
                <li>Router working </li>
                <li>Router Outlet </li>
                <li>Router Link </li>
                <li>Redirecting Router </li>
                <li>Wildcard Router </li>
                <li>Child Router </li>
              </ul>
              <h4>Angular Services </h4>
              <ul>
                <li>Why Angular Services?</li>
                <li>What is Angular Services? </li>
                <li>What is Dependency Injection </li>
                <li>mplementing Angular Services </li>
                <li>Difference between Constructor and ngOnInit </li>
              </ul>
              <h4> Angular Forms </h4>
              <ul>
                <li>Introduction to Forms </li>
                <li>Template Driven Forms </li>
                <li> Form Validations </li>
                <li>Reactive Forms </li>
                <li>From Grouping getvalue and Reset </li>
                <li>setvalue </li>
                <li>patchValue </li>
                <li>Value Change and Status Change </li>
                <li>Form Array</li>
                <li>Radio Button </li>
                <li>Check Boxes </li>
              </ul>
              <h4> Module Loading Techniques </h4>
              <ul>
                <li>Introduction</li>
                <li>Lazy Loading </li>
                <li> Preloading</li>
                <li>Custom Preloading </li>
                <li>Custom Preloading with Delay </li>
              </ul>
              <h4> Observables and Subscribe</h4>
              <ul>
                <li>Observables and Subscribe with Web API</li>
                <li>Observable with Async Pipe </li>
                <li>Observable Map </li>
              </ul>
              <h4> Http Module </h4>
              <ul>
                <li>Http Client</li>
                <li>Difference between Http and Http Client </li>
                <li>Http Client Get, Post, Put, and Delete </li>
              </ul>
              <h4> Session Management </h4>
              <ul>Angular Session Management Techniques</ul>
              <h4> Angular Project </h4>
              <ul>
                <li>Project Using Angular 9</li>
              </ul>
            <br />
            <a href="https://forms.gle/Mqvuq22jVLTcw1fD9">
              <button type="button" class="btn btn-outline-primary">
                Join Angular Course
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
